import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Phone, ShieldCheck, Star, MapPin } from "lucide-react";

const LINES = ["Detailing, Tints, PPF", "& Dash Cam Fitting"];

const lineVariant = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 0.85, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] } }),
};

export const Hero = () => {
  return (
    <section data-testid="hero" className="relative min-h-[100svh] w-full overflow-hidden">
      <div className="absolute inset-0 z-0 bg-[#08090B]" />
      <img src="/images/hero-car.jpg" alt="Porsche GT3 RS" className="absolute inset-0 z-0 h-full w-full object-cover object-[center_66%] sm:object-[72%_center]" />
      <div className="absolute inset-0 z-[1] bg-gradient-to-r from-[#08090B] via-[#08090B]/60 to-transparent" />
      <div className="absolute inset-0 z-[1] bg-gradient-to-t from-[#08090B]/90 via-transparent to-transparent" />
      <div className="absolute inset-0 z-[1] bg-[radial-gradient(circle_at_80%_35%,rgba(23,147,255,0.16),transparent_55%)]" />

      <div className="container-x relative z-10 flex min-h-[100svh] flex-col justify-center pt-28 pb-16">
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }} className="eyebrow mb-5">
          <span className="h-px w-8 bg-[var(--blue-bright)]" /> Clean · Protect · Impress
        </motion.span>

        <h1 className="font-display text-[2.6rem] font-900 leading-[0.98] tracking-tight text-white drop-shadow-[0_2px_18px_rgba(0,0,0,0.65)] sm:text-6xl lg:text-7xl">
          {LINES.map((line, i) => (
            <span key={i} className="block overflow-hidden">
              <motion.span custom={i} variants={lineVariant} initial="hidden" animate="show" className="block">
                {i === 0 ? (
                  <>Detailing, <span className="text-[var(--blue-bright)]">Tints, PPF</span></>
                ) : line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.7 }}
          className="mt-6 max-w-xl text-base leading-relaxed text-white/85 drop-shadow-[0_1px_10px_rgba(0,0,0,0.7)]">
          Professional vehicle protection and care for cars, vans and commercial fleets.
        </motion.p>

        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.85, duration: 0.7 }}
          className="mt-9 flex flex-wrap items-center gap-3">
          <Link to="/#services" data-testid="hero-view-services" className="btn-electric">
            View Services <ArrowRight size={16} />
          </Link>
          <Link to="/#contact" data-testid="hero-contact" className="btn-ghost">
            <Phone size={15} /> Get a Quote
          </Link>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.05, duration: 0.8 }}
          className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 text-xs font-medium text-white/80 sm:text-sm">
          <span className="flex items-center gap-2"><ShieldCheck size={16} className="text-[var(--blue-bright)]" /> Lifetime warranty on dashcam installation</span>
          <span className="flex items-center gap-2"><Star size={16} className="text-[var(--blue-bright)]" /> Premium, affordable finish</span>
          <span className="flex items-center gap-2"><MapPin size={16} className="text-[var(--blue-bright)]" /> Trusted local &amp; mobile service</span>
        </motion.div>
      </div>
    </section>
  );
};
